import React, { useState } from "react";
import "./Navbar.css";
import ContactBtn from "./ContactBtn";
import MenuBtn from "./MenuBtn";
import Logojd from "./Logojd";

const Navbar = ({ show, click }) => {
  const menuClass = ["menu_lines"];

  if (show) {
    menuClass.push("show");
  }

  const [navbar, setNavbar] = useState(false);

  const setNavActive = () => {
    if (window.scrollY >= 80) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };
  window.addEventListener("scroll", setNavActive);

  return (
    <div className={navbar ? "navbar active" : "navbar"}>
      <div className="nav-wrap">
        <a className="logo" href="#home">
          {/* <div>JD</div> */}
          <Logojd />
        </a>

        <div className="nav-links">
          <a className="nav-link-home" href="#home">
            Home
          </a>
          <a href="#about">About</a>
          <a href="#projects">Works</a>
        </div>

        <a href="#contact" className="contact-btn">
          Contact
        </a>

        <div id="menu" className={menuClass.join(" ")} onClick={click}>
          <div className="menu-lines">
            <span></span>
          </div>
          <div>
            <span id="midline"></span>
          </div>
          <div className="menu-lines">
            <span className="menu-lines"></span>
          </div>
        </div>

        {/* <nav>
          <ul class="nav__links">
            <li>
              <a href="/" className="nav_home">
                Home
              </a>
            </li>

            <li>
              <a href="/about" className="nav_home">
                About
              </a>
            </li>

            <li>
              <a href="/projects" className="nav_home">
                Projects
              </a>
            </li>
          </ul>
        </nav>
        <p class="cta">
          <a href="/contact" ClassName="contact-us">
            <ContactBtn />
          </a>
        </p> */}

        {/* <p class="menu cta" onClick={click}>
          <MenuBtn />
        </p> */}
      </div>
    </div>
  );
};

export default Navbar;
